// OAuth payload helpers shared across broker success pages.
//
// Backend redirects now use URL fragments: `/oauth/<broker>/success#payload=...`
// so the token payload is not included in server logs or Referer headers.

export function getOAuthSearchParams(location) {
  return new URLSearchParams(location?.search || "");
}

export function getOAuthHashParams(location) {
  const hash = typeof location?.hash === "string" ? location.hash : "";
  return new URLSearchParams(hash.replace(/^#/, ""));
}

export function getOAuthPayload(location) {
  const hash = getOAuthHashParams(location);
  const search = getOAuthSearchParams(location);
  return hash.get("payload") || search.get("payload");
}

export function getOAuthState(location) {
  const hash = getOAuthHashParams(location);
  const search = getOAuthSearchParams(location);
  return hash.get("state") || search.get("state");
}

export function getOAuthError(location) {
  const hash = getOAuthHashParams(location);
  const search = getOAuthSearchParams(location);
  return search.get("error") || hash.get("error");
}

export function encodeBase64UrlJson(value) {
  try {
    return btoa(JSON.stringify(value))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/g, "");
  } catch (_e) {
    return "";
  }
}

export function decodeBase64UrlJson(payload) {
  if (!payload || typeof payload !== "string") return null;
  try {
    let base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const pad = base64.length % 4;
    if (pad) base64 += "=".repeat(4 - pad);
    return JSON.parse(atob(base64));
  } catch (_e) {
    return null;
  }
}
